import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate, useRoutes } from "react-router-dom";

import { getInvestors, getInvestorsMxailMerge } from "./store/investors";
import { checkToken, setAuthData } from "./store/auth";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Dashboard from "./pages/Dashboard/Dashboard";
import Login from "./pages/Login/Login";
import MailMerge from "./pages/MailMerge/MailMerge";
import DashboardType from "./pages/Dashboard/DashboardType/DashboardType";
import { getFirms } from "./store/firms";
import { getInvestorsWithFirms } from "./store/investorsWithFirms";
import Admin from "./pages/Admin/Admin";
import DatabaseEditor from "./pages/Admin/DatabaseEditor";
import { getUsers } from "./store/users";
import { getCompanies } from "./store/companies";
import { getIntroductions } from "./store/introductions";
import { getFilters } from "./store/filters";
import ErrorBoundary from "./component/ErrorBoundary/ErrorBoundary";

const Layout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  const nav = [
    {
      path: "/dashboard",
      element: (
        <Dashboard>
          <Outlet />
        </Dashboard>
      ),
      children: [
        {
          path: "admin/:type",
          element: (
            <ProtectedRoute
              {...{ auth: auth, requiredType: "Admin", navigate }}
            >
              <Admin />
            </ProtectedRoute>
          ),
        },
        {
          path: "admin/database-editor",
          element: (
            <ProtectedRoute
              {...{ auth: auth, requiredType: "Admin", navigate }}
            >
              <DatabaseEditor />
            </ProtectedRoute>
          ),
        },
        {
          path: "manager/:type",
          element: <Admin type="Manager" />,
        },
        {
          path: "founder/:type",
          element: <Admin type="Founder" />,
        },
        auth.type === "Admin"
          ? {
              path: "type/mail-merge",
              element: <MailMerge />,
            }
          : null,
        {
          path: "directory",
          element: <DashboardType />,
        },
        {
          path: "type/:type",
          element: <DashboardType />,
        },
      ].filter((el) => el),
    },
  ];
  const routes = [
    {
      path: "",
      element: <Login />,
    },
    ...nav,
    {
      path: "/*",
      element: "error",
    },
  ];
  const getAllData = () => {
    dispatch(getInvestorsWithFirms());
    dispatch(getInvestors());
    dispatch(getUsers());
    dispatch(getCompanies());
    dispatch(getFilters());
    if (auth.type === "Admin") {
      dispatch(getInvestorsMxailMerge());
      dispatch(getFirms());
      dispatch(getIntroductions());
    }
  };

  useEffect(() => {
    if (auth?.token) {
      getAllData();
      setInterval(() => {
        getAllData();
      }, 5 * 60 * 1000);
      if (!location.pathname.slice(1)) {
        navigate("/dashboard/type/investor");
      }
    } else {
      let localToken = JSON.parse(localStorage.getItem("appdata"));
      if (localToken?.token) {
        dispatch(checkToken(localToken));
        
      } else {
        localStorage.setItem("apptoken", "");
        navigate("/");
      }
    }
  }, [auth?.token]);
  useEffect(() => {
    if (location?.pathname) {
      if (location?.pathname?.split("/")?.reverse()[0] == "introductions") {
        dispatch(getIntroductions());
      } else if (location?.pathname?.split("/")?.reverse()[0] == "users") {
        dispatch(getUsers());
      } else if (location?.pathname?.split("/")?.reverse()[0] == "companies") {
        dispatch(getCompanies());
      } else if (location?.pathname?.split("/")?.reverse()[0] == "firms") {
        dispatch(getFirms());
      } else {
        dispatch(getInvestorsWithFirms());
        dispatch(getInvestors());
      }
    }
  }, [location?.pathname]);

  return (
    <div className="layout">
      <ErrorBoundary>{useRoutes(routes)}</ErrorBoundary>
    </div>
  );
};

export default Layout;
const ProtectedRoute = ({ auth, requiredType, navigate, children }) => {
  // If user type does not match the required type, redirect to error page
  if (auth?.type !== requiredType) {
    console.log(requiredType);

    if (requiredType == "Manager") {
      navigate("/dashboard/type/investor");
    }
    if (requiredType == "Founder") {
      navigate("/dashboard/type/investor");
    } else {
      if (requiredType == "Admin") {
        return <></>;
      }
      navigate("/dashboard/type/investor");
    }
    return <></>;
  }

  // If the user is authorized, render the children components
  return children;
};
